import { createApp } from 'vue'
import StartPage from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from './router'
import store from '@/store'
import ElementPlus from 'element-plus'
import { refreshPublicKey, showLoading, closeLoading } from '@/tools'
import { i18n } from '@/languages'
import { showMessage } from '@/tools'
import { tc } from '@/languages'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import '@/style/index.css'

axios.queue = 0;

axios.interceptors.request.use((config) => {
    //console.log(config);
    config.headers.Authorization = "Bearer " + localStorage.getItem('JWT');
    if (axios.queue == 0) showLoading();
    axios.queue++;
    return config;
}, function (error) {
    if (error) {
        console.error(error);
        showMessage('error', tc('global.RequestFailed'))
    }    
    return Promise.reject(error);
});

axios.interceptors.response.use((res) => {
    axios.queue--;
    if (axios.queue == 0) closeLoading();
    if (res.data.success != undefined && !res.data.success) {
        console.error(res);
        //showMessage('error', tc('global.ResponseFailed'));
    }
    return res.data;
}, function (error) {
    if (error) {
        console.error(error);
        showMessage('error', tc('global.ResponseFailed'))
    }
    return Promise.reject(error);
});

refreshPublicKey();

let Vue = createApp(StartPage);

Vue.use(ElementPlus)
    .use(VueAxios, axios)
    .use(router)
    .use(store)
    .use(i18n)
    .mount('#app');


